import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Card,
  CardContent,
  Grid,
  Chip,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const UserProfile = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography>Loading user profile...</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        User Profile
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Personal Information
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Username
                  </Typography>
                  <Typography variant="body1">{user.username}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Email
                  </Typography>
                  <Typography variant="body1">{user.email}</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Subscription Details
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Subscription Tier
                  </Typography>
                  <Chip 
                    label={user.subscription_tier.toUpperCase()} 
                    color={
                      user.subscription_tier === 'premium' ? 'secondary' : 
                      user.subscription_tier === 'basic' ? 'primary' : 'default'
                    }
                  />
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Subscription Status
                  </Typography>
                  <Chip 
                    label={user.subscription_status.toUpperCase()} 
                    color={
                      user.subscription_status === 'active' ? 'success' :
                      user.subscription_status === 'trialing' ? 'info' :
                      user.subscription_status === 'past_due' ? 'warning' : 'error'
                    }
                  />
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Last Login
                  </Typography>
                  <Typography variant="body1">
                    {user.last_login ? new Date(user.last_login).toLocaleString() : 'Never'}
                  </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Account Created
                  </Typography>
                  <Typography variant="body1">
                    {user.created_at ? new Date(user.created_at).toLocaleString() : 'Unknown'}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default UserProfile;